import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../lib/api";
import { Card, Empty, Tag } from "./bits";

export const FeatureFlags = () => {
  const [flags, setFlags] = useState(null);
  const load = () => api.get("/admin/flags").then((r) => setFlags(r.data)).catch(() => setFlags([]));
  useEffect(() => { load(); }, []);
  const toggle = async (f) => {
    if (!f.enabled && !window.confirm(`Enable "${f.label}"?\n\n${f.note}`)) return;
    try { await api.put(`/admin/flags/${f.key}`, { enabled: !f.enabled }); toast.success(`${f.key} ${!f.enabled ? "enabled" : "disabled"} — reload to apply in the UI`); load(); } catch (ex) { toast.error(errText(ex)); }
  };
  if (!flags) return <Empty>Loading…</Empty>;
  return (
    <Card className="mt-4" title="Feature flags" sub="Superadmin only. Defaults come from backend/.env; overrides are stored in the database and audited." testId="feature-flags">
      {flags.length === 0 && <Empty>Superadmin only.</Empty>}
      {flags.map((f) => (
        <div key={f.key} className="kv" style={{ alignItems: "flex-start", padding: "10px 0" }} data-testid={`flag-${f.key}`}>
          <span><b className="mono">{f.key}</b><div className="sub" style={{ margin: "2px 0 0" }}>{f.label}</div><div className="sub" style={{ margin: "2px 0 0", color: "var(--ink-2)" }}>{f.note}</div></span>
          <span className="flex gap-2 items-center"><Tag kind={f.enabled ? "ok" : "warn"} testId={`flag-status-${f.key}`}>{f.enabled ? "ON" : "OFF"}</Tag>
            <button className={`btn sm ${f.enabled ? "danger" : ""}`} onClick={() => toggle(f)} data-testid={`flag-toggle-${f.key}`}>{f.enabled ? "Turn off" : "Turn on"}</button></span>
        </div>
      ))}
    </Card>
  );
};
